import React from 'react';

export function Activity() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28.914"
      height="33.019"
      viewBox="0 0 28.914 33.019">
      <g data-name="Group 3320" transform="translate(-549.126 -251.862)">
        <g data-name="Group 3117" transform="translate(558.582 274.879)">
          <circle
            cx="3.831"
            cy="3.831"
            r="3.831"
            fill="#fff"
            data-name="Ellipse 38"
            transform="translate(1.17 1.17)"></circle>
          <path
            fill="#374adb"
            d="M568.269 296.286a5 5 0 115-5 5.007 5.007 0 01-5 5zm0-7.662a2.661 2.661 0 102.66 2.661 2.664 2.664 0 00-2.66-2.661z"
            data-name="Path 2617"
            transform="translate(-563.267 -286.284)"></path>
        </g>
        <g data-name="Group 3122" transform="translate(550.374 256.034)">
          <g data-name="Group 3118" transform="translate(3.819)">
            <path
              fill="#fff"
              d="M558.453 268.071a8.22 8.22 0 018.22-8.22"
              data-name="Path 2618"
              transform="translate(-557.283 -258.681)"></path>
            <path
              fill="#374adb"
              d="M557.874 268.661a1.17 1.17 0 01-1.17-1.17 9.4 9.4 0 019.39-9.39 1.17 1.17 0 010 2.34 7.057 7.057 0 00-7.05 7.05 1.171 1.171 0 01-1.17 1.17z"
              data-name="Path 2619"
              transform="translate(-556.704 -258.101)"></path>
          </g>
          <g data-name="Group 3119" transform="translate(0 8.22)">
            <path
              fill="#fff"
              d="M565.981 286.341H553.9a2.463 2.463 0 01.189-4.232s3.021-.944 2.474-9.965"
              data-name="Path 2620"
              transform="translate(-551.572 -270.974)"></path>
            <path
              fill="#374adb"
              d="M565.4 286.931h-12.082a1.172 1.172 0 01-.715-.243 4.162 4.162 0 01-1.61-3.068 3.814 3.814 0 011.823-3.035c.136-.1.159-.136.3-.165.277-.18 2.13-1.666 1.7-8.785a1.17 1.17 0 011.1-1.239 1.185 1.185 0 011.239 1.1c.521 8.6-2.091 10.613-3.058 11.06a1.68 1.68 0 00-.759 1.09 1.543 1.543 0 00.451.948H565.4a1.17 1.17 0 010 2.34zm-12.244-6.519z"
              data-name="Path 2621"
              transform="translate(-550.993 -270.394)"></path>
          </g>
          <g data-name="Group 3120" transform="translate(11.97)">
            <path
              fill="#fff"
              d="M578.863 268.071a8.22 8.22 0 00-8.22-8.22"
              data-name="Path 2622"
              transform="translate(-569.473 -258.681)"></path>
            <path
              fill="#374adb"
              d="M578.283 268.661a1.17 1.17 0 01-1.17-1.17 7.057 7.057 0 00-7.05-7.05 1.17 1.17 0 110-2.34 9.4 9.4 0 019.39 9.39 1.17 1.17 0 01-1.17 1.17z"
              data-name="Path 2623"
              transform="translate(-568.893 -258.101)"></path>
          </g>
          <g data-name="Group 3121" transform="translate(10.769 8.22)">
            <path
              fill="#fff"
              d="M568.848 286.341h12.083a2.463 2.463 0 00-.189-4.232s-3.021-.944-2.474-9.965"
              data-name="Path 2624"
              transform="translate(-567.678 -270.974)"></path>
            <path
              fill="#374adb"
              d="M580.351 286.931h-12.083a1.17 1.17 0 010-2.34h11.618a1.548 1.548 0 00.451-.948 1.685 1.685 0 00-.759-1.089c-.967-.447-3.579-2.461-3.058-11.06a1.17 1.17 0 112.336.141c-.431 7.119 1.422 8.605 1.7 8.785.142.029.163.066.3.165a3.815 3.815 0 011.823 3.035 4.165 4.165 0 01-1.612 3.068 1.17 1.17 0 01-.716.243zm.161-6.519"
              data-name="Path 2625"
              transform="translate(-567.098 -270.394)"></path>
          </g>
        </g>
        <g data-name="Group 3123" transform="translate(558.163 265.854)">
          <ellipse
            cx="4.73"
            cy="5.853"
            fill="#fff"
            data-name="Ellipse 39"
            rx="4.73"
            ry="5.853"></ellipse>
        </g>
        <g data-name="Group 3124" transform="translate(562.413 251.932)">
          <path
            fill="#fff"
            d="M0 3.433L0 0"
            data-name="Line 146"
            transform="translate(1.17 1.17)"></path>
          <path
            fill="#374adb"
            d="M570.167 257.74a1.17 1.17 0 01-1.17-1.17v-3.434a1.17 1.17 0 112.34 0v3.434a1.171 1.171 0 01-1.17 1.17z"
            data-name="Path 2626"
            transform="translate(-568.997 -251.966)"></path>
        </g>
        <g data-name="Group 3125" transform="translate(549.126 251.862)">
          <path
            fill="#fff"
            d="M550.995 265.733a11.805 11.805 0 015.884-12.12"
            data-name="Path 2627"
            transform="translate(-549.697 -252.442)"></path>
          <path
            fill="#374adb"
            d="M550.42 266.322a1.166 1.166 0 01-1.142-.926 13.1 13.1 0 016.424-13.364 1.17 1.17 0 111.21 2 10.576 10.576 0 00-5.343 10.881 1.172 1.172 0 01-.909 1.381 1.127 1.127 0 01-.24.028z"
            data-name="Path 2628"
            transform="translate(-549.126 -251.862)"></path>
        </g>
        <g data-name="Group 3126" transform="translate(569.688 251.862)">
          <path
            fill="#fff"
            d="M587.511 265.733a11.805 11.805 0 00-5.884-12.12"
            data-name="Path 2629"
            transform="translate(-580.457 -252.442)"></path>
          <path
            fill="#374adb"
            d="M586.932 266.324a1.116 1.116 0 01-.243-.025 1.17 1.17 0 01-.9-1.382 10.576 10.576 0 00-5.342-10.881 1.17 1.17 0 111.21-2 13.1 13.1 0 016.423 13.364 1.17 1.17 0 01-1.148.924z"
            data-name="Path 2630"
            transform="translate(-579.877 -251.862)"></path>
        </g>
      </g>
    </svg>
  );
}
